import React from 'react';
import { cx } from '@emotion/css';
import { styles } from './BuyBtn.styles';

export const KinohodBuyBtn = ({ className, onClick, buyText = 'КУПИТЬ БИЛЕТЫ', kinohodId }) => {
  if (!kinohodId) {
    return null
  }

  return (
    <button
      onClick={() => onClick(kinohodId)}
      className={cx(styles.btn, className)}
    >
      {buyText}
    </button>
  )
}

export const LinkBtn = ({ text, url, className }) => {
  return (
    <a
      href={url}
      target={"_blank"}
      className={cx(styles.btn, className)} rel="noreferrer"
    >
      {text}
    </a>
  )
}
